/* Cet fichier permet d'ajouter de nouveaux textes ET de surcharger si besoin est les textes existants */

let specific = {}

export default specific
